const UserTabType = {
  USER_DETAIL: 0,
  USER_SUPPLIER: 1,
  USER_DISTRIBUTER: 2,
  USER_AGENT: 3,
  USER_CUSTOMER: 4,
  USER_SITE: 5
}
export default UserTabType
